import type { PollAnswerPayload } from './dashboard-polls.backend-model';

/**
 * A poll displayed on the dashboard (https://www.freelancer.com/dashboard).
 */
export interface DashboardPoll {
  readonly id: number;
  readonly question: string;
  readonly pollAnswerType?: PollAnswerType;
  readonly options: readonly PollOption[];
  readonly answered: boolean;
  readonly submitDate: number;
  readonly hide?: boolean;
  readonly answer?: readonly PollAnswerPayload[];
}

export interface PollOption {
  readonly id: number;
  readonly pollId: number;
  readonly answer: string;
  readonly isOtherField: boolean;
  readonly orderId: number;
}

export enum PollAnswerType {
  RADIO = 'radio',
  INPUT = 'input',
  TEXT_AREA = 'text_area',
  CHECKBOX = 'checkbox',
}
